import React from 'react';
import { FormattedMessage } from 'react-intl';
import { QueryResult } from '@apollo/client';
import { Button } from '@99designs/frontend-components/components/Button';
import { Spinner } from '@99designs/frontend-components/components/Spinner';
import { IconExclamationPoint1, IconInfo1 } from '@99designs/icons';
import { RecentChats, RecentChatsVariables } from '../../__generated__/RecentChats';
import { OnsiteMessagesListItem } from '../OnsiteMessagesListItem/OnsiteMessagesListItem';

export interface OnsiteMessagesListProps {
    queryResult: QueryResult<RecentChats, RecentChatsVariables>;
}

export class OnsiteMessagesList extends React.Component<OnsiteMessagesListProps> {
    render() {
        const { client, data, error, loading, refetch } = this.props.queryResult;

        if (loading) {
            return (
                <div className="onsite-messages__loading">
                    <Spinner variations={['medium']} />
                </div>
            );
        }

        if (error || !data) {
            return (
                <div className="onsite-messages__error">
                    <span className="onsite-messages__error-icon">
                        <IconExclamationPoint1 />
                    </span>
                    <div className="onsite-messages__error-content">
                        <h2 className="onsite-messages__error-content__heading">
                            <FormattedMessage
                                id="Unable to load messages"
                                defaultMessage="Unable to load messages"
                            />
                        </h2>
                        <FormattedMessage
                            id="An error occured and we were unable to load your messages."
                            defaultMessage="An error occured and we were unable to load your messages."
                        />
                        <Button
                            variations={['primary', 'small']}
                            onClick={() => client.resetStore().then(() => refetch())}
                        >
                            <FormattedMessage id="Try again" defaultMessage="Try again" />
                        </Button>
                    </div>
                </div>
            );
        }

        const { recentChats, viewer } = data;

        if (recentChats.length && viewer) {
            return (
                <ul className="scrollable-dropdown__list">
                    {recentChats.map((chat) => (
                        <li key={chat.id} className="scrollable-dropdown__list-item">
                            <OnsiteMessagesListItem
                                key={chat.id}
                                isActive={false} // TODO: Not sure when other User is active
                                chat={chat}
                                viewer={viewer}
                            />
                        </li>
                    ))}
                </ul>
            );
        } else {
            return !viewer ? (
                <div className="onsite-messages__info">
                    <FormattedMessage
                        id="Please log in to view your messages"
                        defaultMessage="Please log in to view your messages"
                    />
                </div>
            ) : (
                <div className="onsite-messages__message-none">
                    <span className="onsite-messages__message-none-icon">
                        <IconInfo1 />
                    </span>
                    <div className="onsite-messages__message-none-content">
                        <h2 className="onsite-messages__message-none-content__heading">
                            <FormattedMessage
                                id="You have no messages"
                                defaultMessage="You have no messages"
                            />
                        </h2>
                        {viewer.isDesigner && (
                            <FormattedMessage
                                id="When you receive new messages, you will see them here."
                                defaultMessage="When you receive new messages, you will see them here."
                            />
                        )}

                        {!viewer.isDesigner && (
                            <>
                                <FormattedMessage
                                    id="Find a designer and message them directly from their profile."
                                    defaultMessage="Find a designer and message them directly from their profile."
                                />
                                <Button variations={['primary', 'small']} href="/designers/search">
                                    <FormattedMessage
                                        id="Find a designer"
                                        defaultMessage="Find a designer"
                                    />
                                </Button>
                            </>
                        )}
                    </div>
                </div>
            );
        }
    }
}
export default OnsiteMessagesList;
